const item = "_item_lqfwq_8";
const interactive = "_interactive_lqfwq_26";
const label = "_label_lqfwq_34";
const icon = "_icon_lqfwq_50";
const disabled = "_disabled_lqfwq_118";
const styles = {
  item,
  interactive,
  "no-label": "_no-label_lqfwq_30",
  label,
  "no-icon": "_no-icon_lqfwq_41",
  icon,
  "nav-hint": "_nav-hint_lqfwq_59",
  disabled
};
export {
  styles as default,
  disabled,
  icon,
  interactive,
  item,
  label
};
//# sourceMappingURL=MenuItem.module.css.js.map
